import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRoutes from '@/views/home/router'
import databaseRoutes from '@/views/database/router'
import machineLearningRoutes from '@/views/machine-learning/router'
import globalSearchRoutes from '@/views/global-search/router'
import predictionRoutes from '@/views/prediction/router'
import survivalRoutes from '@/views/survival/router'
import aboutRoutes from '@/views/about/router'
import downloadRoutes from '@/views/download/router'

Vue.use(VueRouter)

const routes = [
  ...homeRoutes,
  ...databaseRoutes,
  ...machineLearningRoutes,
  ...globalSearchRoutes,
  ...predictionRoutes,
  ...survivalRoutes,
  ...aboutRoutes,
  ...downloadRoutes
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
